module.exports = "<ag-sales-list\n  [requestObject]=\"requestObject\"\n  [options]=\"{ refundDate: false }\"\n>\n</ag-sales-list>\n"